import React, { useEffect, useState } from 'react'
// import Main1 from "../../../assets/images/we-do-1.jpg"
// import Main2 from "../../../assets/images/we-do-2.jpg"
// import Main3 from "../../../assets/images/we-do-3.jpg"
import Slider from 'react-slick'
import { Link } from 'react-router-dom'
import { axiosInstance, config } from '../config'
// import { slugGenerator } from '../../../utils/slugGenerator'
import moment from 'moment'

const Blog = ({ Line }) => {

    const [News, setNews] = useState([]);
    const [Loading, setLoading] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
        getCustomersInfo();
    }, []);

    function getCustomersInfo() {
        setLoading(true);
        axiosInstance.get(`news`)
            .then(res => {
                setNews(res?.data?.news);
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setLoading(false);
            });
    }

    const settings = {
        dots: false,
        fade: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        waitForAnimate: false,
        arrows: false,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 760,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <div>
            <div id="rs-blog" className="rs-blog blog-main-home pt-115 pb-120 md-pt-75 md-pb-80">
                <div className="container">
                    <div className="sec-title mb-60 md-mb-40 text-center">
                        <span className="sub-text pb-10">Latest News</span>
                        <h2 className="title">
                            Check Now Our Latest<br />
                            <span> News </span> Blog
                        </h2>
                        <div className="line-img blog-center wow fadeInUp" >
                            <img src={Line} alt="Images" />
                        </div>
                    </div>
                    <Slider {...settings} >
                        {News?.map((blogs, i) => {
                            return (
                                <div className='px-md-3 pb-20 pt-3'>
                                    <div className="blog-item">
                                        <div className="image-wrap">
                                            <Link to={`${config.appUrl}news/${blogs?.slug}`}>
                                                <img src={blogs?.imageUrl} alt="" className='h-100 w-100 object-fit-cover'/>
                                            </Link>
                                            <ul className="post-categories">
                                                <li><Link to={`${config.appUrl}news/${blogs?.slug}`}>{blogs?.category}</Link></li>
                                            </ul>
                                        </div>
                                        <div className="blog-content">
                                            <ul className="blog-meta" style={{listStyle:"outside none"}}>
                                                <li className="admin"><i className="bi bi-calendar-week-fill"></i>{moment(blogs?.created_at).format("MMM D, YYYY")}</li>
                                                <li className="date"><i className="bi bi-person"></i>Admin</li>
                                            </ul>
                                            <h3 className="blog-title" style={{height:"70px"}}><Link to={`${config.appUrl}news/${blogs?.slug}`}>{blogs?.title}</Link></h3>
                                            <div className="blog-btn">
                                                <Link to={`${config.appUrl}news/${blogs?.slug}`}>
                                                    <span className="btn-text">
                                                        Read More
                                                    </span>
                                                    <i className="bi bi-arrow-right-short"></i>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </Slider>
                </div>
            </div>
        </div >
    )
}

export default Blog
